import { fetchFeaturePermissions } from '@va/aaas/shared/api-client';
import { AaasFeaturePermission } from '@va/aaas/shared/types';
import { apiStatus } from '@va/constants';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { call, put, select } from 'redux-saga/effects';
import { setFeaturePermissions, setFeaturePermissionsStatus } from '@va/aaas/shared/actions';

export function* fetchFeaturePermissionsSaga(): Generator {
  const websiteId = (yield select(getInstanceId)) as string;

  try {
    yield put(setFeaturePermissionsStatus(apiStatus.IN_PROGRESS));
    const data = (yield call(fetchFeaturePermissions, websiteId)) as AaasFeaturePermission[];
    yield put(setFeaturePermissionsStatus(apiStatus.SUCCEEDED));
    yield put(setFeaturePermissions(data));
  } catch (error) {
    yield put(setFeaturePermissionsStatus(apiStatus.FAILED));
    console.error(error);
  }
}
